import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigService } from "src/app/configurations/services/config.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class MembershipService {
  private headerObj: object;
  private httpOptions;
  LogData = [];
  constructor(private http: HttpClient, private encDecService: ConfigService) {}

  GetPlansbyMembershipTypeID(MembershipTypeID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetPlansbyMembershipTypeID?MemberShipTypeID=" +
        MembershipTypeID +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetAllMembershipAppointmentByPatientID(
    MembershipPatientLinkID,
    MembershipPatientGroupID,
    PatientID
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetAllMembershipOfPatientsByMembershipPatientLinkID?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&IsGroup=" +
        MembershipPatientGroupID +
        "&PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetMembershipPlanDetailsByPlanID(PlanID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetMembershipPlanDetailsByPlanID?PlanID=" +
        PlanID +
        "&CurrentDate=" +
        new Date()
    );
  }

  InsertMembershipPatientLink(
    PatientID,
    MembershipPlanID,
    AssignedDentistID,
    AssignedOfficeFrontID,
    Amount
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/InsertMembershipPatientWithOnlyRecomendedPlan?PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&MembershipPlanID=" +
        MembershipPlanID +
        "&AssignedDentistID=" +
        this.encDecService.enc(AssignedDentistID.toString()) +
        "&AssignedOfficeFrontID=" +
        this.encDecService.enc(AssignedOfficeFrontID.toString()) +
        "&Amount=" +
        Amount +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdateMembershipPatientLink(
    MembershipPatientLinkID,
    RecomendedMemberShipPlanID,
    AssignedDentistID,
    AssignedOfficeFrontID,
    Amount
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/UpdateMembershipPatientLink?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&RecomendedMemberShipPlanID=" +
        RecomendedMemberShipPlanID +
        "&AssignedDentistID=" +
        this.encDecService.enc(AssignedDentistID.toString()) +
        "&AssignedOfficeFrontID=" +
        this.encDecService.enc(AssignedOfficeFrontID.toString()) +
        "&Amount=" +
        Amount +
        "&CurrentDate=" +
        new Date()
    );
  }

  // live     GN94-CW51-ME15-PZ84
  // JP38-RH99-BP34-TN92
  VerifyAccounts(AccountNumber, SortCode) {
    return this.http.get(
      "https://api.addressy.com/BankAccountValidation/Batch/Validate/v1.00/json3.ws?Key="+environment.bankVerificationKey+"&AccountNumbers=" +
        AccountNumber +
        "&SortCodes=" +
        SortCode
    );
  }

  InsertMembershipOtherPatients(
    OtherPatientsData,
    OtherDetails,
    MembershipPatientLinkID
  ) {
    return this.http.post(
      environment.configUrl +
        "Membership/InsertMembershipOtherPatients?OtherDetails=" +
        OtherDetails +
        "&MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date(),
      OtherPatientsData
    );
  }

  UploadMemberShipPDF(
    PDFData,
    MembershipPatientLinkID,
    MembershipPatientLinkData
  ) {
    const data = {
      PDFData: this.encDecService.enc(JSON.stringify(PDFData)),
      MembershipPatientLinkData: this.encDecService.enc(
        JSON.stringify(MembershipPatientLinkData)
      ),
    };
    return this.http.post(
      environment.configUrl +
        "Membership/UploadMemberShipPDF?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        // "&MembershipPatientLinkData=" +
        // JSON.stringify(MembershipPatientLinkData) +
        "&CurrentDate=" +
        new Date(),
      data
    );
  }

  UploadMemberShipUpdatePDF(PDFData) {
    const data = {
      PDFData: this.encDecService.enc(JSON.stringify(PDFData)),
    };
    return this.http.post(
      environment.configUrl +
        "Membership/UploadMemberShipUpdatePDF?CurrentDate=" +
        new Date(),
      data
    );
  }

  InsertMembershipPlanPatientLink(
    MembershipPlanID,
    PatientID,
    MembershipPatientLinkID,
    AppointmentScheduleSlotLevelID
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/InsertMembershipPlanPatientLink?MembershipPlanID=" +
        MembershipPlanID +
        "&PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&AppointmentScheduleSlotLevelID=" +
        this.encDecService.enc(AppointmentScheduleSlotLevelID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  DeleteOtherMember(MembershipPatientLinkID) {
    return this.http.get(
      environment.configUrl +
        "Membership/DeleteMembershipOtherPatientsLinkByMembershipOtherPatientsLinkID?MembershipOtherPatientsLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdateCompleteMembershipPatientAndOtherPatients(MembershipData, IsAdd) {
    const data = {
      MembershipData: this.encDecService.enc(JSON.stringify(MembershipData)),
    };
    // this.encDecService.enc(JSON.stringify(MembershipData))
    return this.http.post(
      environment.configUrl +
        "Membership/UpdateCompleteMembershipPatientAndOtherPatients?IsAdd=" +
        IsAdd +
        "&CurrentDate=" +
        new Date(),
      data
    );
  }

  GetAllMembershipHistoryByPatientID(
    PatientID,
    IsGroup,
    IsPaidPatient,
    StartDate,
    EndDate
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetAllMembershipHistoryByPatientID?PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&IsGroup=" +
        IsGroup +
        "&IsPaidPatient=" +
        IsPaidPatient +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate +
        "&CurrentDate=" +
        new Date()
    );
  }

  VerifyMemberShip(PatientID) {
    return this.http.get(
      environment.configUrl +
        "Membership/IsMembershipAvailableForPatientID?PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetLinkedFamilyMembers(PatientID) {
    return this.http.get(
      environment.configUrl +
        "Patient/GetFamilyMembersByPatientID?PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetFamilyMembersByPatientAddress(PatientID, PatientFamilyGroupID) {
    return this.http.get(
      environment.configUrl +
        "Patient/GetFamilyMembersByPatientAddress?PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&PatientFamilyGroupID=" +
        PatientFamilyGroupID +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetAllFamilyMembersForAddingOtherMembers(PatientID, MembershipPatientLinkID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetAllFamilyMembersForAddingOtherMembers?PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  FindPatientByPatientDataForMembership(PatientData) {
    const data = {
      PatientData: this.encDecService.enc(JSON.stringify(PatientData)),
    };
    return this.http.post(
      environment.configUrl +
        "Patient/FindPatientByPatientDataForMembership?CurrentDate=" +
        new Date(),
      data
    );
  }

  InsertMembershipPatientForAddingOtherMember(
    MembershipPatientLinkID,
    MembershipPatientGroupID
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/InsertMembershipPatientForAddingOtherMember?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&MembershipPatientGroupID=0" +
        "&CurrentDate=" +
        new Date()
    );
  }

  CancelMembershipAndUpdateScheme(
    MembershipPatientLinkID,
    PatientID,
    Scheme,
    IsArchived
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/CancelMembershipAndUpdateScheme?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&Scheme=" +
        Scheme +
        "&IsArchived=" +
        IsArchived +
        "&CurrentDate=" +
        new Date()
    );
  }

  UploadMemberShipDeletePDF(PDFData) {
    const data = {
      PDFData: this.encDecService.enc(JSON.stringify(PDFData)),
    };
    return this.http.post(
      environment.configUrl +
        "Membership/UploadMemberShipDeletePDF?CurrentDate=" +
        new Date(),
      data
    );
  }

  UpdateMembershipFromApprovedToCancel(MembershipPatientLinkID) {
    return this.http.get(
      environment.configUrl +
        "Membership/UpdateMembershipFromApprovedToCancel?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UploadMembershipPDFFiles(MembershipPatientLinkID, Documents) {
    this.headerObj = new HttpHeaders({
      ContentType: null,
      Accept: "multipart/form-data",
    });
    this.httpOptions = {
      headers: this.headerObj,
    };
    return this.http.post(
      environment.configUrl +
        "Membership/UploadMembershipPDFFiles?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date(),
      Documents
    );
  }

  UpdateMembershipStatusFromApprovedToActive(
    MembershipPatientLinkID,
    PaidPatientID,
    IsFinancialHead,
    IsFromSystem,
    IsAnnual
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/UpdateMembershipStatusFromApprovedToActive?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&PaidPatientID=" +
        this.encDecService.enc(PaidPatientID.toString()) +
        "&IsFinancialHead=" +
        IsFinancialHead +
        "&IsFromSystem=" +
        IsFromSystem +
        "&IsAnnual=" +
        IsAnnual +
        "&CurrentDate=" +
        new Date()
    );
  }

  UpdateMembershipStatusFromApprovedToActiveoffline(
    PatientID,
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/UpdateMembershipStatusFromApprovedToActiveoffline?PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }


  GetAllMembershipPDFByMembershipPatientLinkID(MembershipPatientLinkID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetAllMembershipPDFByMembershipPatientLinkID?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetPDFDataByMembershipPatientLinkID(MembershipPatientLinkID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetPDFDataByMembershipPatientLinkID?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  ResendMembership(
    FileName,
    Patient,
    PracticeAdmin,
    Membership,
    PDFData,
    IsSystem
  ) {
    const data = {
      PDFData: this.encDecService.enc(JSON.stringify(PDFData)),
    };
    return this.http.post(
      environment.configUrl +
        "Membership/ResendMembership?FileName=" +
        this.encDecService.enc(FileName.toString()) +
        "&Patient=" +
        Patient +
        "&PracticeAdmin=" +
        PracticeAdmin +
        "&Membership=" +
        Membership +
        "&IsSystem=" +
        IsSystem +
        "&CurrentDate=" +
        new Date(),
      data
    );
  }

  ReGenerateMembership(
    Patient,
    PracticeAdmin,
    Membership,
    PDFData,
    MembershipPatientLinkData,
    IsBankUpdate,
    IsPaymentTermChange
  ) {
    const data = {
      PDFData: this.encDecService.enc(JSON.stringify(PDFData)),
      MembershipPatientLinkData: this.encDecService.enc(
        JSON.stringify(MembershipPatientLinkData)
      ),
    };
    return this.http.post(
      environment.configUrl +
        "Membership/ReGenerateMembership?Patient=" +
        Patient +
        "&PracticeAdmin=" +
        PracticeAdmin +
        "&Membership=" +
        Membership +
        // "&MembershipPatientLinkData=" +
        // JSON.stringify(MembershipPatientLinkData) +
        "&IsBankUpdate=" +
        IsBankUpdate +
        "&IsPaymentTermChange=" +
        IsPaymentTermChange +
        "&CurrentDate=" +
        new Date(),
      data
    );
  }

  GetAllListAssoicatedMembersInMembership(MembershipPatientLinkID, PatientID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetAllListAssoicatedMembersInMembership?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  InsertPatientFamilyLink(
    PatientFamilyGroupID,
    PatientData,
    PrimaryPatientID,
    IsFamilyHead
  ) {
    var Data = {
      PatientData: this.encDecService.enc(JSON.stringify(PatientData)),
    };
    return this.http.post(
      environment.configUrl +
        "Membership/InsertPatientFamilyLink?PatientFamilyGroupID=" +
        PatientFamilyGroupID +
        "&PrimaryPatientID=" +
        this.encDecService.enc(PrimaryPatientID.toString()) +
        "&IsFamilyHead=" +
        IsFamilyHead +
        "&CurrentDate=" +
        new Date(),
      Data
    );
  }


  GetPatienMemberAdvanceSearchImplementation(ArchiveFlag, SearchPattern) {
    var pattern = JSON.stringify(SearchPattern)
    return this.http.get(
      environment.configUrl +
        "Membership/GetPatientMemberAdvanceSearchImplementation?ArchiveFlag=" +
        ArchiveFlag +
        "&SearchPattern=" +pattern
        +
        "&CurrentDate=" +
        new Date()
    );
  }


  GetAllMembershipOfPatients(
    MembershipPatientLinkID,
    PatientID,
    IsGroup,
    StaffID
  ) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetAllMembershipOfPatients?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&IsGroup=" +
        IsGroup +
        "&StaffID=" +
        this.encDecService.enc(StaffID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  UploadMemberShipPDFReInsertion(MembershipPatientLinkData, PDFData) {
    const data = {
      PDFData: this.encDecService.enc(JSON.stringify(PDFData)),
      MembershipPatientLinkData: this.encDecService.enc(
        JSON.stringify(MembershipPatientLinkData)
      ),
    };
    return this.http.post(
      environment.configUrl +
        "Membership/UploadMemberShipPDFReInsertion?CurrentDate=" +
        new Date(),
      data
    );
  }

  UpdateIsAnnualForMembershipPatientLink(MembershipPatientLinkID) {
    return this.http.get(
      environment.configUrl +
        "Membership/UpdateIsAnnualForMembershipPatientLink?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  InsertMembershipNotes(NotesData, MembershipPatientLinkID) {
    var Data = { NotesData: NotesData };
    return this.http.post(
      environment.configUrl +
        "Membership/InsertMembershipNotes?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&CurrentDate=" +
        new Date(),
      Data
    );
  }

  GetMembershipNotes(MembershipPatientLinkID, PatientID) {
    return this.http.get(
      environment.configUrl +
        "Membership/GetMembershipNotes?MembershipPatientLinkID=" +
        this.encDecService.enc(MembershipPatientLinkID.toString()) +
        "&PatientID=" +
        this.encDecService.enc(PatientID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }

  GetStaffWithMembershipPermission() {
    return this.http.get(
      environment.configUrl +
        "Membership/GetStaffWithMembershipPermission?CurrentDate=" +
        new Date()
    );
  }
}

// InsertPatientFamilyLink(PatientFamilyGroupID, PatientData, PrimaryPatientID, IsFamilyHead) {
//   return this.http.get(environment.configUrl + 'Membership/InsertPatientFamilyLink?PatientFamilyGroupID=' + PatientFamilyGroupID + '&PatientData=' + PatientData + '&PrimaryPatientID=' + this.encDecService.enc(PrimaryPatientID.toString()) + '&IsFamilyHead=' + IsFamilyHead + '&CurrentDate=' + new Date());
// }

// SingUp(PatientData) {
//   const data = {
//     SignUpData: this.encDecService.enc(JSON.stringify(PatientData)),
//   };
//   return this.http.post(
//     environment.configUrl + "Patient/PatientSignUp?CurrentDate=" + new Date(),
//     data
//   );
// }

// UpdatePatientDetails(PatientDetails) {
//   const data = {
//     PatientDetails: this.encDecService.enc(JSON.stringify(PatientDetails)),
//   };
//   return this.http.post(
//     environment.configUrl +
//       "Patient/UpdatePatientDetails?CurrentDate=" +
//       new Date(),
//     data
//   );
// }
// PatientAlternativeLogin(FirstName, LastName, DOB) {
//   const LoginData = {
//     FirstName,
//     LastName,
//     DOB,
//   };
//   return this.http.get(
//     environment.configUrl +
//       "Patient/PatientAlternativeLogin?LoginData=" +
//       this.encDecService.enc(JSON.stringify(LoginData)) +
//       "&CurrentDate=" +
//       new Date()
//   );
// }
